import AppAccessProvider from "../cnr/contexts/AppAccessContext";
import AppAdminProvider from "../cnr/contexts/AppAdminContext";
import AppComponentProvider from "../cnr/contexts/AppComponentContext";
import AppDataProvider from "../cnr/contexts/AppDataContext";
import AppFormsProvider from "../cnr/contexts/AppFormsContext";
import AppMonitorProvider from "../cnr/contexts/AppMonitor";
import AppNotificationsProvider from "../cnr/contexts/AppNotificationsContext";
import AppUserProvider from "../cnr/contexts/AppUserContext";
import ConversationProvider from "../cnr/contexts/AppUserDataContext";
import AppUsersAuthProvider from "../cnr/contexts/AppUsersAuthContext";
import BaseSettingsProvider from '../cnr/contexts/BaseSettingsContext';
import ClientInfoProvider from "../cnr/contexts/ClientInfoContext";
import CredentialingProvider from "../cnr/contexts/CredentialingContext";
import DemoProvider from "../cnr/contexts/DemoContext";
import EventInfoProvider from "../cnr/contexts/EventInfoContext";
import FirestoreProvider from "../cnr/contexts/FirestoreContext";
import GoogleScriptsProvider from "../cnr/contexts/GoogleScriptsContext";
import GoogleSheetsProvider from "../cnr/contexts/GoogleSheetsContext";
import HeaderProvider from "../cnr/contexts/HeaderContext";
import HomeInfoProvider from "../cnr/contexts/HomeInfoContext";
import LocationsProvider from "../cnr/contexts/LocationContext";
import { NavigationProvider } from "../cnr/contexts/NavigationContext";
import PageProvider from "../cnr/contexts/PageContext";
import ParentProvider from "../cnr/contexts/ParentContext";
import PreviewProvider from "../cnr/contexts/PreviewContext";
import RoutesProvider from "../cnr/contexts/RoutesContext";
import StartDataProvider from "../cnr/contexts/StartDataContext";
import StorageProvider from "../cnr/contexts/StorageContext";
import TransitionProvider from "../cnr/contexts/TransitionContext";
import ValidationProvider from "../cnr/contexts/ValidationContext";
import VideoConferenceProvider from "../cnr/contexts/VideoConferenceContext";
import { googleSheetsTypes } from "../cnr/reducers/GoogleSheetsReducer";
import AppPage from './AppPage';

const transitionType = 'css'

const GoogleIntegrationProviders = ({ children }) => (
  <GoogleScriptsProvider>
    <GoogleSheetsProvider googleSheetsType={googleSheetsTypes.app}>
      {children}
    </GoogleSheetsProvider>
  </GoogleScriptsProvider>
);

/**
 * 
 * @param {*} param0 
 * @returns VideoConferenceProvider, LocationsProvider, CredentialingProvider, GoogleIntegrationProviders, ConversationProvider
 */
const ComponentProviders = ({ children }) => (
  <VideoConferenceProvider>
    <LocationsProvider>
      <CredentialingProvider>
        <GoogleIntegrationProviders> {/* Grouped Above */}
          <ConversationProvider>
            {children}
          </ConversationProvider>
        </GoogleIntegrationProviders>
      </CredentialingProvider>
    </LocationsProvider>
  </VideoConferenceProvider>
);

/**
 * 
 * @param {*} param0 
 * @returns HomeInfoProvider, ClientInfoProvider, EventInfoProvider  
 */
const HceInfoProviders = ({ children }) => (
  <HomeInfoProvider>
    <ClientInfoProvider>
      <EventInfoProvider>
        {children}
      </EventInfoProvider>
    </ClientInfoProvider>
  </HomeInfoProvider>
);

/** Starting point fo the App 
@includes PageProvider  
@includes AppAccessProvider   
@includes AppUserProvider  
@includes StorageProvider   
@includes ClientInfoProvider
@includes StaticViewsProvider   
@includes AppNotificationsProvider  
@includes ConversationProvider  
@includes UpdateProvider  
@includes AppFormsProvider  
@includes AppDataProvider  
@includes AppPage  
*/
const AppView = (props) => {
  return (
    <PreviewProvider>
      {/* <DemoProvider> */}
      <PageProvider {...props} >
        <RoutesProvider>
          <AppUserProvider>
            <NavigationProvider>
              <BaseSettingsProvider>
                <AppFormsProvider>
                  <ValidationProvider>
                    <AppAccessProvider>
                      <HceInfoProviders> {/* Grouped Above home, client, event */}
                        <AppDataProvider>
                          <StorageProvider>
                            <AppUsersAuthProvider>  {/* Auth Only and authOn */}
                              <AppAdminProvider>
                                <AppMonitorProvider>
                                  <AppNotificationsProvider>
                                    <StartDataProvider>
                                      <TransitionProvider>
                                        <ParentProvider>
                                          <ComponentProviders>  {/* Grouped Above - incl Google Sheets */}
                                            <FirestoreProvider>
                                              <HeaderProvider>
                                                <AppComponentProvider>
                                                  {/* <AppDummy /> */}
                                                  {/* Contains PageSwitch */}
                                                  {/* <MotionLayout /> */}
                                                  <AppPage transitionType={transitionType} />
                                                </AppComponentProvider>
                                              </HeaderProvider>
                                            </FirestoreProvider>
                                          </ComponentProviders>
                                        </ParentProvider>
                                      </TransitionProvider>
                                    </StartDataProvider>
                                  </AppNotificationsProvider>
                                </AppMonitorProvider>
                              </AppAdminProvider>
                            </AppUsersAuthProvider>
                          </StorageProvider>
                        </AppDataProvider>
                      </HceInfoProviders>
                    </AppAccessProvider>
                  </ValidationProvider>
                </AppFormsProvider>
              </BaseSettingsProvider>
            </NavigationProvider>
          </AppUserProvider>
        </RoutesProvider>
      </PageProvider>
      {/* </DemoProvider> */}
    </PreviewProvider>
  )
}

export default AppView